import { Dispatch, SetStateAction } from 'react'

const getEmptySetter = <T>(): Dispatch<SetStateAction<T>> => () => {
  // noop
}

export default getEmptySetter
